import React, { memo } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { TableCell, TableRow } from '@mui/material';
import { Autocomplete, IconButton, TextField } from '@totalsoft/rocket-ui';
import CancelIcon from '@mui/icons-material/Cancel';

const LeasingExpensesRowComponent = ({
  idx,
  item,
  leasingExpenseTypes,
  onPropertyChange,
  onDelete,
  validationInfo,
  disabled,
  addDeleteFees,
  financialFeesWrite
}) => {
  const handleExpenseTypeChange = value => {
    onPropertyChange(idx, 'leasingExpenseTypeId', value);
  };

  const handleCurrencyValueChange = value => {
    onPropertyChange(idx, 'currencyValue', value);
  };

  const handleDelete = () => {
    onDelete(idx);
  };

  return (
    <React.Fragment>
      <TableRow>
        <TableCell>
          <Autocomplete
            id={'leasingExpensesCard_' + idx + '_leasingExpenseName'}
            fullWidth
            simpleValue={true}
            value={item.leasingExpenseTypeId}
            labelKey='leasingExpenseName'
            valueKey='leasingExpenseTypeId'
            error={Boolean(validationInfo && validationInfo.leasingExpenseTypeId)}
            helperText={validationInfo && validationInfo.leasingExpenseTypeId}
            onChange={handleExpenseTypeChange}
            options={leasingExpenseTypes}
            disabled={disabled || item.isMandatory || item.isReadOnly || !financialFeesWrite}
          />
        </TableCell>
        <TableCell>
          <TextField
            id={'leasingExpensesCard_' + idx + '_currencyValue'}
            fullWidth
            required
            isNumeric
            name='currencyValue'
            value={item.currencyValue || ''}
            onChange={handleCurrencyValueChange}
            error={validationInfo && Boolean(validationInfo.currencyValue)}
            helperText={validationInfo && validationInfo.currencyValue}
            disabled={disabled || item.isReadOnly || !financialFeesWrite}
          />
        </TableCell>
        <TableCell sx={{ textAlign: 'end' }}>
          <IconButton
            id={'leasingExpensesCard_' + idx + '_deleteBtn'}
            color='primary'
            variant='text'
            size='small'
            onClick={handleDelete}
            disabled={disabled || item.isMandatory || !financialFeesWrite || !addDeleteFees}
          >
            <CancelIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};
LeasingExpensesRowComponent.propTypes = {
  item: PropTypes.object.isRequired,
  leasingExpenseTypes: PropTypes.array.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  validationInfo: PropTypes.object.isRequired,
  idx: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
  addDeleteFees: PropTypes.bool.isRequired,
  financialFeesWrite: PropTypes.bool.isRequired
};

export default compose(withTranslation())(memo(LeasingExpensesRowComponent));
